import React, { useState } from "react";
import { Helmet } from "react-helmet";
import "./Gallery.css";
import HeroAddress from "../heroAddress/HeroAddress";

// Import images
import heroImage from "../../assets/images/gallery-hero.png";
import img1 from "./photos/photo1.jpg";
import img2 from "./photos/photo2.jpg";
import img3 from "./photos/photo3.jpg";
import img4 from "./photos/photo4.jpg";
import img5 from "./photos/photo5.jpg";
import img6 from "./photos/photo6.png";
import img7 from "./photos/photo7.png";
import img8 from "./photos/photo8.png";
import img9 from "./photos/photo9.png";
import img10 from "./photos/photo10.png";

const images = [
  { src: img1, alt: "Hot food buffet station with assorted stir-fry" },
  { src: img2, alt: "Spicy crawfish in hot sauce" },
  { src: img3, alt: "Cubed sashimi including salmon and tuna" },
  { src: img4, alt: "Plated sushi rolls with spicy mayo and avocado" },
  { src: img5, alt: "Fresh clams on ice" },
  { src: img6, alt: "Cream puff desserts with whipped topping" },
  { src: img7, alt: "Fresh oysters on the half shell with sauce" },
  { src: img8, alt: "Teriyaki glazed chicken wings and drumsticks" },
  { src: img9, alt: "Snow crab legs stacked over ice" },
  {
    src: img10,
    alt: "Free birthday meal promotion sign with confetti and neon text",
  },
];

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <>
      <Helmet>
        <title>Gallery | Hiro Japanese Buffet & Arcade</title>
        <meta
          name="description"
          content="View our photo gallery featuring delicious sushi, hibachi, seafood, desserts, and birthday celebrations at Hiro Japanese Buffet in Aurora, CO."
        />
        <meta
          name="keywords"
          content="Hiro Buffet Gallery, sushi photos, hibachi pictures, buffet images, Japanese food Aurora"
        />
        <link
          rel="canonical"
          href="https://www.hirojapanesebuffet.com/gallery"
        />
      </Helmet>

      <HeroAddress title="GALLERY" imageUrl={heroImage} />

      <section id="gallery">
        <div className="gallery-wrapper">
          <h2 className="gallery-heading">🍱 A Taste of Hiro</h2>
          <p className="gallery-subheading">
            Explore photos from our buffet, hibachi grill, events, and more.
          </p>

          <div className="gallery-grid" role="list">
            {images.map((img, i) => (
              <img
                key={i}
                src={img.src}
                alt={img.alt}
                className="gallery-img"
                role="listitem"
                tabIndex="0"
                onClick={() => setSelectedImage(img)}
                onKeyDown={(e) => e.key === "Enter" && setSelectedImage(img)}
              />
            ))}
          </div>
        </div>

        {/* Lightbox */}
        {selectedImage && (
          <div
            className="lightbox"
            onClick={() => setSelectedImage(null)}
            onKeyDown={(e) => e.key === "Escape" && setSelectedImage(null)}
            role="dialog"
            aria-modal="true"
            tabIndex="-1"
          >
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="lightbox-img"
            />
          </div>
        )}
      </section>
    </>
  );
};

export default Gallery;
